import { memo } from 'react';

import { PaneContainer } from '~/components/FileStatusTrackingPane/PaneContainer';
import { ZippingTaskCompletedPanelItem } from '~/components/ZippingTasks/ZippingTaskCompletedPanelItem';
import { ZippingTaskFailedPanelItem } from '~/components/ZippingTasks/ZippingTaskFailedPanelItem';
import { ZippingTaskInProgressPanelItem } from '~/components/ZippingTasks/ZippingTaskInProgressPanelItem';
import { type GetTaskInStatus, type ZippingTask } from '~/store/tasks/types';

export type ZippingTasksPanelProps = {
  zippingTasks: ZippingTask[];
  onCancel: (localTaskId: ZippingTask['localTaskId']) => void;
  onClear: (localTaskId: ZippingTask['localTaskId']) => void;
  onHandleExpiredLink: (remoteTaskId: GetTaskInStatus<ZippingTask, 'completed'>['remoteTaskId']) => void;
  onRetryFailed: (task: ZippingTask) => void;
};

export const ZippingTasksPanel = memo(
  ({ zippingTasks, onCancel, onClear, onHandleExpiredLink, onRetryFailed }: ZippingTasksPanelProps) => {
    return (
      <div data-testid="ZIPPING_TASK_PANEL">
        {zippingTasks.map((zipping) => {
          return (
            <PaneContainer key={zipping.localTaskId} className="mb-2 last:mb-0">
              {zipping.status === 'in-progress' ? (
                // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — task id is bound per list item
                <ZippingTaskInProgressPanelItem onCancel={() => onCancel(zipping.localTaskId)} {...zipping} />
              ) : null}
              {zipping.status === 'completed' ? (
                <ZippingTaskCompletedPanelItem
                  // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — task id is bound per list item
                  onHandleExpiredLink={() => onHandleExpiredLink(zipping.remoteTaskId)}
                  // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — task id is bound per list item
                  onClear={() => onClear(zipping.localTaskId)}
                  {...zipping}
                />
              ) : null}
              {zipping.status === 'error' ? (
                <ZippingTaskFailedPanelItem
                  // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — task id is bound per list item
                  onClear={() => onClear(zipping.localTaskId)}
                  // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — task id is bound per list item
                  onRetry={() => onRetryFailed(zipping)}
                  {...zipping}
                />
              ) : null}
            </PaneContainer>
          );
        })}
      </div>
    );
  },
);

ZippingTasksPanel.displayName = 'ZippingFilesPanel';
